import { render, staticRenderFns } from "./SearchCity.vue?vue&type=template&id=2bb8707c"
import script from "./SearchCity.vue?vue&type=script&lang=js"
export * from "./SearchCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports